<template>
    <form action="" method="post" @submit.prevent="" autocomplete="off">
        <div :key="errors" v-if="errors" class="alert alert-soft-danger" role="alert">
            {{ errors.message }}
            <ul class="list-pointer list-pointer-sm list-pointer-danger">
                <li v-for="(msg, error) in errors.errors" class="list-pointer-item ">{{ error }}: {{ msg[0] }}</li>
            </ul>
        </div>
        <div>
            <fieldset>
                <div class="row">
                    <div class="mb-3 col-md-12">
                        <label class="fs-6 mb-0 --form-label --mb-1" for="org_name">{{ $t('Organization') }}</label>
                        <h4>{{ user.org_name }}</h4>
                    </div>
                </div>
                <div class="row">
                    <div class="mb-3 col-md-9">
                        <label class="fs-6 mb-0 --form-label --mb-1" :for="`${idPrefix}-email-field`">{{ $t('Email') }}</label>
                        <input :readonly="user.id > 0" :placeholder="$t('Email')" autocomplete="new-email-field"
                               class="form-control form-control-sm" v-model="user.email" name="email"
                               :id="`${idPrefix}-email-field`"/>
                    </div>
                    <div class="mb-3 col-md-3" v-if="is_org_type_clinical === false">
                        <label class="form-label">&nbsp;</label>
                        <div class="d-flex align-items-center justify-content-between mb-4">
                            <label class="fs-6 mb-0 --form-label --mb-1 bold-label" :for="`${idPrefix}-clinical-user-field`">
                                {{ $t('Clinical User') }}
                            </label>
                            <div class="form-check form-switch">
                                <input type="checkbox" class="form-check-input" v-model="user.is_clinician"
                                       name="is_clinician"
                                       :id="`${idPrefix}-clinical-user-field`" :checked="user.is_clinician">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="!(user.id > 0)">
                    <div class="mb-3 col-md-9">
                        <label class="fs-6 mb-0 --form-label --mb-1 bold-label" :for="`${idPrefix}-confirm-email-field`">{{ $t('Confirm Email') }}</label>
                        <input onpaste="return false;" aria-required="true" :placeholder="$t('Confirm Email')"
                               autocomplete="new-email-field-2" class="form-control form-control-sm bold-input"
                               v-model="user.confirm_email" name="confirm_email" :id="`${idPrefix}-confirm-email-field`"/>
                    </div>
                </div>
                <div class="row">
                    <div class="mb-3 col-md-4">
                        <label class="fs-6 mb-0 --form-label --mb-1" :for="`${idPrefix}-first-name-field`">
                            {{ $t('First Name') }}
                        </label>
                        <input :placeholder="$t('First Name')" class="form-control form-control-sm" v-model="user.first_name"
                               name="first_name" :id="`${idPrefix}-first-name-field`"/>
                    </div>
                    <div class="mb-3 col-md-4">
                        <label class="fs-6 mb-0 --form-label --mb-1" :for="`${idPrefix}-last-name-field`">
                            {{ $t('Last Name') }}
                        </label>
                        <input :placeholder="$t('Last Name')" class="form-control form-control-sm" v-model="user.last_name"
                               name="last_name" :id="`${idPrefix}-last-name-field`"/>
                    </div>
                    <div class="mb-3 col-md-4">
                        <label class="fs-6 mb-0 --form-label --mb-1" :for="`${idPrefix}-phone-field`">
                            {{ $t('Mobile Phone') }}
                        </label>
                        <VueTelInput type="tel" mode="auto" :only-countries="['US', 'PR']" :valid-characters-only="true"
                                     :input-options="{ styleClasses: ['form-control form-control-sm'], placeholder: $t('Phone'), name: 'phone', id: `${idPrefix}-phone-field`}"
                                     :key="user.id" :value="user.phone || ''" @input="handlePhoneChange"></VueTelInput>
                        <small v-if="user.two_factor_sms_enabled" class="text-xs text-success">
                            {{ $t('SMS verified') }}
                        </small>
                        <p class="text-danger" v-if="errorMessagePhone">{{ errorMessagePhone }}</p>
                    </div>
                </div>
                <div class="row" v-if="userTypes.length > 0">
                    <div class="mb-3 col-md-9">
                        <label class="fs-6 mb-0 --form-label --mb-1" for="user-create-user-type-field">
                            {{ $t('User Type') }}
                        </label>
                        <select class="form-control form-control-sm form-select" v-model="selectedUserTypeIndex"
                                name="user_type" id="user-create-user-type-field">
                            <option class="form-control" v-for="(userType, index) in userTypes" :value="index">
                                {{ userType.name }}
                            </option>
                        </select>
                    </div>
                    <div class="mb-3 col-md-3" v-if="userTypes.length > 0">
                        <label class="fs-6 mb-0 --form-label --mb-1" for="user-create-user-role-field">
                            {{ $t("User Role") }}
                        </label>
                        <select class="form-control form-control-sm form-select"
                                v-model="selectedUserRole"
                                @change="userRoleChange"
                                name="user_role" id="user-create-user-role-field">
                            <option class="form-control" v-for="role in getUserTypeRoles" :value="role.id">{{
                                    role.label
                                }}
                            </option>
                        </select>
                    </div>
                    <template v-if="showPersonalAccessTokens" >
                        <PersonalAccessTokens :key="user.id" :auth_user="auth_user" :user_id="user.id"></PersonalAccessTokens>
                    </template>
                </div>


<!--                <div class="row" >-->
                <div class="row">
                    <div class="col-md-6 mt-2" v-if="org_settings && org_settings.ess_utility && showServicePlusUnlockToggle">
                        <div class="d-flex align-items-center mb-4">
                            <label class="fs-6 mb-0 me-2 --form-label --mb-1 bold-label" :for="`${idPrefix}-service-plus-unlock`">
                                {{ $t('Service+ Unlock') }}
                            </label>
                            <div class="form-check form-switch">
                                <input type="checkbox" class="form-check-input" :value="user.is_ess_visible"
                                       name="is_clinician"
                                       @change="(event) => user.is_ess_visible = event.target.checked"
                                       :id="`${idPrefix}-service-plus-unlock`" :checked="user.is_ess_visible">
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 mt-2" v-if="org_settings && org_settings.allow_ventilator_support && org_settings.ventilator_visibility === 'specific-users'">
                        <div class="d-flex align-items-center mb-4">
                            <label class="fs-6 mb-0 me-2 --form-label --mb-1 bold-label" :for="`${idPrefix}-ventilator-access-field`">
                                {{ $t('Ventilator Patients Access') }}
                            </label>
                            <div class="form-check form-switch">
                                <input type="checkbox" class="form-check-input" :value="user.mvc_settings?.enabled"
                                       name="is_clinician"
                                       @change="(event) => user.mvc_settings = {...user.mvc_settings, enabled: event.target.checked}"
                                       :id="`${idPrefix}-ventilator-access-field`" :checked="user.mvc_settings?.enabled">
                            </div>
                        </div>
                    </div>
                </div>

<!--                <div class="row" >-->
                <div class="row">

                </div>


                <div class="row">
                    <AppDualListBox
                        v-if="selectedUserTypeIndex !== null && userTypes[selectedUserTypeIndex].name === 'Location'"
                        :all-options="computedLocations"
                        :selected-options="user.roleLocations"
                        :disabled-options="sessionUserLocations"
                        :name-index="`name`"
                        :all-options-label="$t('Location Search')"
                        :selected-options-label="$t('Assigned Locations')"
                        @selectedValuesUpdated="updateSelectedLocations"
                    >
                        <template v-slot:originalOptions="{ options, selectOption }">
                            <li v-for="option in options" :key="option['id']" @click="selectOption(option)">
                                <span :style="{ color: buildOptionFontColor(option, 'locations') }">
                                    {{ option['name'] }}
                                </span>
                            </li>
                        </template>

                        <template v-slot:selectedOptions="{ options, deselectOption }">
                            <li v-for="option in options" :key="option['id']" @click="deselectOption(option)">
                                <span :style="{ color: buildOptionFontColor(option, 'locations') }">
                                    {{ option['name'] }}
                                </span>
                            </li>
                        </template>
                    </AppDualListBox>
                </div>

                <div class="row">
                    <AppDualListBox v-if="selectedUserTypeIndex !== null && userTypes[selectedUserTypeIndex].name === 'Group'"
                                    :all-options="computedGroups"
                                    :selected-options="user.roleGroups"
                                    :name-index="`group_name`"
                                    :disabled-options="sessionUserGroups"
                                    :all-options-label="$t('Group Search')"
                                    :selected-options-label="$t('Assigned Groups')"
                                    @selectedValuesUpdated="updateSelectedGroups"
                    >
                        <template v-slot:originalOptions="{ options, selectOption }">
                            <li v-for="option in options" :key="option['id']" @click="selectOption(option)">
                                <span :style="{ color: buildOptionFontColor(option, 'groups') }">
                                    {{ option['group_name'] }}
                                </span>
                            </li>
                        </template>

                        <template v-slot:selectedOptions="{ options, deselectOption }">
                            <li v-for="option in options" :key="option['id']" @click="deselectOption(option)">
                                <span :style="{ color: buildOptionFontColor(option, 'groups') }">
                                    {{ option['group_name'] }}
                                </span>
                            </li>
                        </template>
                    </AppDualListBox>
                </div>
            </fieldset>
        </div>
    </form>
</template>

<script setup>
import AppDualListBox from "../../shared/AppDualListBox.vue";
import {VueTelInput} from 'vue3-tel-input';
import 'vue3-tel-input/dist/vue3-tel-input.css';
import {computed, defineEmits, inject, onMounted, ref, watch, getCurrentInstance} from "vue";
import AppAlert from "@/vue/shared/dialog/AppAlert.vue";
import AppConfirm from "@/vue/shared/dialog/AppConfirm.vue";
import {trans as $t} from "@/vue/composables/missingTranslations";
import isEqual from 'lodash/isEqual';
import {createConfirmDialog} from "vuejs-confirm-dialog";
import PersonalAccessTokens from "./PersonalAccessTokens.vue";
import usePermissions from "@/vue/composables/usePermissions";
import {fetchGroups, fetchLocations, invalidateCache} from '@/vue/orgApiHelper';
import {useUserStore} from "@/vue/store/userStore";

const showPersonalAccessTokens = ref(false);
const showServicePlusUnlockToggle = ref(false);
const tokenKey = ref(0);
const { hasPermission } = usePermissions();

const props = defineProps({
    org_id: {
        type: Number,
        required: false
    },
    is_org_type_clinical: {
        type: Boolean,
        required: true,
        default: false
    },
    user: {
        type: Object,
        required: false,
        default: {
            user_id: null,
            country: 'US',
            roles: [],
            user_type: [{}],
            org_group_id: null,
            confirm_email: '',
            phone: '',
            is_clinician: true,
            roleGroups: [],
            roleLocations: [],
            newRole: null,
            locationsChanged: false,
            groupsChanged: false,
            roleChanged: false,
            mvc_settings: {}
        }
    },
    scope: {
        type: String,
        required: false,
        default: 'all'
    },
    org_locations: {
        type: Array,
        required: false,
        default: null
    },
    org_groups: {
        type: Array,
        required: false,
        default: null
    },
    org_settings: {
        type: Object,
        required: false,
        default: null
    },
    idPrefix: {
        type: String,
        required: false,
        default: 'user-create'
    },
});

const emit = defineEmits(['user-error', 'user-success', 'user-saving-canceled']);

const baseUrl = '/api/users'
const incorrectPhone = $t('Incorrect phone number format entered.');

const locations = ref([]);
const location = ref({});
const group = ref({});
const groups = ref([]);
const userTypes = ref([]);
const loaded = ref(false);
const saving = ref(false);
const errors = ref(null);
const selectedUserTypeIndex = ref(null);
const selectedUserRole = ref(null);
const errorMessagePhone = ref(null);
const originalLocations = ref(null);
const originalGroups = ref(null);
const originalRole = ref(null);
const originalUserType = ref(null);
const sharedState = inject('sharedState');

const userStore = useUserStore();
const auth_user = computed(() => userStore.user);
const org = computed(() => userStore.org);

const {reveal: alert} = createConfirmDialog(AppAlert);
const {reveal: confirm} = createConfirmDialog(AppConfirm);

const sessionUserLocations = computed(() => {
    const allLocations = [];
    if (hasPermission(auth_user.value.can, 'addAll.org.location.user'))  {
        return allLocations;
    }
    allLocations.push(...locations.value);
    if (Array.isArray(props.user?.roleLocations)) {
        allLocations.push(...props.user.roleLocations);
    }
    const allowedLocations = auth_user.value.locations;
    if (hasPermission(auth_user.value.can, 'view.org.groups.locations'))  {
        auth_user.value.groups?.forEach(group => {
            if (group?.locations?.length > 0) {
                allowedLocations.push(...group.locations);
            }
        });
    }
    return allLocations.filter(location => allowedLocations.filter(user_location => user_location.id === location.id).length === 0);
});
const sessionUserGroups = computed(() => {
    const allGroups = [];
    if (hasPermission(auth_user.value.can, 'addAll.org.group.user'))  {
        return allGroups;
    }
    allGroups.push(...groups.value);
    if (Array.isArray(props.user?.roleGroups)) {
        allGroups.push(...props.user.roleGroups);
    }
    return allGroups.filter(group => auth_user.value.groups.filter(user_group => user_group.id === group.id).length === 0);
});

const buildOptionFontColor = (option, type) => {
    if (type === 'groups') {
        if (sessionUserGroups.value.filter(disabledOption => disabledOption['id'] === option['id']).length) {
            return '#c9d7e5';
        }
    } else if (type === 'locations') {
        if (sessionUserLocations.value.filter(disabledOption => disabledOption['id'] === option['id']).length) {
            return '#c9d7e5'
        }
    }
    return option.active !== undefined && !option.active ? 'red' : 'black'
}

const createUser = async (user) => {
    if (!user) {
        user = props.user;
    }

    const isPasswordReset = user.password && user.password_confirmation;

    if (!isPasswordReset) {
        delete user.password;
        delete user.password_confirmation;
    }

    if (errorMessagePhone.value) {
        errors.value = errorPhoneNumber.value;
        emit('user-error', errorPhoneNumber.value);
        return;
    }

    if (user.id) {
        if (selectedUserTypeIndex.value !== null && userTypes.value[selectedUserTypeIndex.value].id !== originalUserType.value && props.user.user_type && props.user.user_type.length > 0 && userTypes.value[selectedUserTypeIndex.value].id !== props.user.user_type[0].id) {
            user.userTypeChanged = true;
        } else {
            user.userTypeChanged = false;
        }

        if (user.locationsChanged === true || user.groupsChanged || user.roleChanged === true || user.userTypeChanged === true ) {
            const confirmed = await confirmWindow($t("Warning!"), $t("messages.user_access_warning_message"));
            if (confirmed.isCanceled === true) {
                emit('user-saving-canceled');
                return;
            }
        }

        user.org_id = props.org_id;
        user.phone ? user.phone = props.user.phone.replace(/\D/g, '') : null;
        axios.patch(baseUrl, user,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'access-control-allow-origin': '*'
                }
            })
            .then(response => {
                if (response.hasOwnProperty('response') && response.response.hasOwnProperty('status') && response.response.status === 422) {
                    errors.value = response.response.data;
                    emit('user-error', response.response.data);
                } else {
                    if (response.status === 201 || response.status === 200) {
                        if (props.scope !== 'all') {
                            invalidateCache('groups');
                            invalidateCache('locations');
                        }
                        emit('user-success', response.data);
                    }
                }

            }).catch(error => {
                if (error.hasOwnProperty('response') && error.response.hasOwnProperty('status') && error.response.status === 422) {
                    errors.value = error.response.data;
                    emit('user-error', errors.value);
                } else {
                    emit('user-error', {message: $t('An unexpected error has occurred. Please try again later or contact the site administrators for assistance.')});
                }
            })
            .finally(() => {
                saving.value = false;
            });
    } else {
        user.org_id = props.org_id;
        user.phone ? user.phone = props.user.phone.replace(/\D/g, '') : null;
        axios.post(baseUrl, user,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'access-control-allow-origin': '*'
                }
            })
            .then(response => {
                if (response.hasOwnProperty('response') && response.response.hasOwnProperty('status') && response.response.status === 422) {
                    errors.value = response.response.data;
                    emit('user-error', response.response.data);
                } else {
                    if (response.status === 201 || response.status === 200) {
                        if (props.scope !== 'all') {
                            invalidateCache('groups');
                            invalidateCache('locations');
                            sharedState.value.reloadUsers = true;
                        }
                        emit('user-success', response.data);
                    }
                }

            }).catch(error => {
            if (error.hasOwnProperty('response') && error.response.hasOwnProperty('status') && error.response.status === 422) {
                errors.value = error.response.data;
                emit('user-error', errors.value);
            } else {
                emit('user-error', {message: $t('An unexpected error has occurred. Please try again later or contact the site administrators for assistance.')});
            }

        })
            .finally(() => {
                saving.value = false;
            });
    }
};

const getLocations = async (orgId) => {
    return new Promise((resolve, reject) => {
        axios.get('/api/orgs/' + orgId + '/locations/')
            .then(response => {
                locations.value = response.data;
                resolve(response.data);
            })
            .catch(error => {
                reject(error);
            });
    });
};

const getGroups = async (orgId) => {
    return new Promise((resolve, reject) => {
        axios.get('/api/orgs/' + orgId + '/groups/')
            .then(response => {
                groups.value = response.data;
                resolve(response.data);
            })
            .catch(error => {
                reject(error);
            });
    });
};

const getUserTypes = async (orgId) => {
    if (orgId !== null && orgId !== undefined) {
        let url = '/api/user-types/' + orgId;
        const params = new URLSearchParams();
        if (props.scope === 'location' && props.is_org_type_clinical === false) {
            params.set('name', 'Location');
        }
        if (props.scope === 'group') {
            params.set('name', 'Group');
        }
        axios.get(url, {
            params
        }).then(response => {
            userTypes.value = response.data;
        });
    }
}

const setUserTypeValue = () => {
    if (selectedUserTypeIndex.value === null) {
        const defaultUserTypeId = props.user?.user_type?.[0]?.id ?? 1;
        const index = userTypes.value.findIndex(userType => userType.id === defaultUserTypeId);

        selectedUserTypeIndex.value = index !== -1 ? index : null;
    }

    const hasUserData =
        props.user?.id &&
        Array.isArray(props.user.roles) &&
        props.user.roles.length > 0 &&
        selectedUserTypeIndex.value !== null;

    if (hasUserData) {
        if (selectedUserRole.value === null) {
            selectedUserRole.value = props.user.roles[0].id;
        }

        const selectedUserType = userTypes.value[selectedUserTypeIndex.value];
        const matchedRole = selectedUserType.roles.find(role => role.id === selectedUserRole.value);

        const assigningUserHasPermission = hasPermission(auth_user.value.can, 'api.token.generate') ?? false;
        const assignedRoleHasPermission = matchedRole?.permissions.includes('api.token.access') ?? false;

        showPersonalAccessTokens.value = assigningUserHasPermission && assignedRoleHasPermission;

        const assigningUserHasServicePlusUnlockPermission = hasPermission(auth_user.value.can, 'add.extendedSoftwareService') ?? false;
        const assignedRoleHasServicePlusUnlockPermission = matchedRole?.permissions.includes('add.extendedSoftwareService') ?? false;

        showServicePlusUnlockToggle.value = assigningUserHasServicePlusUnlockPermission && assignedRoleHasServicePlusUnlockPermission;
    }
};

const userRoleChange = () => {
    if (!props.user?.id || selectedUserTypeIndex.value === null) {
        return;
    }

    const selectedUserType = userTypes.value[selectedUserTypeIndex.value];
    const matchedRole = selectedUserType.roles.find(role => role.id === selectedUserRole.value);

    const assigningUserHasPermission = hasPermission(auth_user.value.can, 'api.token.generate') ?? false;
    const assignedRoleHasPermission = matchedRole?.permissions.includes('api.token.access') ?? false;

    showPersonalAccessTokens.value = assigningUserHasPermission && assignedRoleHasPermission;

    const assigningUserHasServicePlusUnlockPermission = hasPermission(auth_user.value.can, 'add.extendedSoftwareService') ?? false;
    const assignedRoleHasServicePlusUnlockPermission = matchedRole?.permissions.includes('add.extendedSoftwareService') ?? false;

    showServicePlusUnlockToggle.value = assigningUserHasServicePlusUnlockPermission && assignedRoleHasServicePlusUnlockPermission;
};

const formatUserLocationsGroups = (user) => {
    user.roleLocations = [];
    user.roleGroups = [];
    if (Array.isArray(user.user_type)) {
        for (const userType of user.user_type) {
            if (userType.name === 'Location') {
                for (const location of locations.value) {
                    if (location.id === userType.pivot.accessible_id) {
                        user.roleLocations.push(location);
                    }
                }
            } else if (userType.name === 'Group') {
                for (const group of groups.value) {
                    if (group.id === userType.pivot.accessible_id) {
                        user.roleGroups.push(group);
                    }
                }
            }
        }
    }
}

const validatePhoneNumber = (phone) => {
    const rawNumber = phone.replace(/\D/g, '');

    let formattedNumber = '';
    if (rawNumber.length >= 1) {
      formattedNumber = '(' + rawNumber.substring(0, 3);
    }
    if (rawNumber.length >= 4) {
      formattedNumber += ') ' + rawNumber.substring(3, 6);
    }
    if (rawNumber.length >= 7) {
      formattedNumber += '-' + rawNumber.substring(6, 10);
    }

    props.user.phone = formattedNumber;

    const regex = /^\(\d{3}\) \d{3}-\d{4}$/;
    if (!regex.test(props.user.phone) || props.user.phone.length > 14) {
        errorMessagePhone.value = errorPhoneNumber.message;
    } else {
        errorMessagePhone.value = '';
    }
}

const updateSelectedLocations = (newLocations) => {
    if (originalLocations.value !== null && Array.isArray(originalLocations.value) && !isEqual(originalLocations.value.slice().sort((a, b) => a.id - b.id), newLocations.slice().sort((a,b) => a.id - b.id))) {
        props.user.locationsChanged = true;
    } else {
        props.user.locationsChanged = false;
    }
    props.user.roleLocations = newLocations;
}

const updateSelectedGroups = (newGroups) => {
    if (originalGroups.value !== null && Array.isArray(originalGroups.value) && !isEqual(originalGroups.value.slice().sort((a,b) => a.id - b.id), newGroups.slice().sort((a,b) => a.id - b.id))) {
        props.user.groupsChanged = true;
    } else {
        props.user.groupsChanged = false;
    }
    props.user.roleGroups = newGroups;
}

const resetUser = () => {
    props.user.email = null;
    props.user.confirm_email = null;
    props.user.first_name = null;
    props.user.last_name = null;
    props.user.phone = '';
    props.user.is_clinician = true;
    props.user.roleGroups = [];
    props.user.roleLocations = [];
    props.user.user_type = [];
    props.user.locationsChanged = false;
    props.user.groupsChanged = false;

    selectedUserTypeIndex.value = null;
    selectedUserRole.value = null;
}

const resetErrors = () => {
    errors.value = null;
}

const resetUserTypes = () => {
    showPersonalAccessTokens.value = false;
    selectedUserTypeIndex.value = null;
    selectedUserRole.value = null;
}

const handlePhoneChange = (e) => {
    if (typeof e === 'object' && e.hasOwnProperty('isTrusted') && e.isTrusted === true) {
        validatePhoneNumber(e.target.value)
    }
}

const confirmWindow = async (title, message) => {
    return await confirm({
            title: title,
            message: message,
            confirmButtonText: $t("Yes"),
            cancelButtonText: $t("No")
        }
    );
}

const setOriginalLocations = (locations) => {
    originalLocations.value = locations;
}

const setOriginalGroups = (groups) => {
    originalGroups.value = groups;
}

const setOriginalRole = (role) => {
    originalRole.value = role;
}

const setOriginalUserType = (userType) => {
    originalUserType.value = userType;
}

const computedLocations = computed(() => {
    return locations.value;
})

const computedGroups = computed(() => {
    return groups.value;
})

const getUserTypeRoles = computed(() => {
    let newVal = true;
    setUserTypeValue();
    if (selectedUserTypeIndex.value !== null) {
        const selectedUserType = userTypes.value[selectedUserTypeIndex.value];
        if (props.is_org_type_clinical || props.user.is_clinical) {
            return selectedUserType.roles.filter(item => item.name.match(/org.clinical/)) || [];
        }
        for (const role of selectedUserType.roles) {
            if (role.id === selectedUserRole.value) {
                newVal = false;
            }
        }
        if (newVal === true) {
            props.user.newRole = null;
            delete props.user.roleGroups;
            delete props.user.roleLocations;
        }
        return selectedUserType.roles || [];
    } else {
        return [];
    }
})

const errorPhoneNumber = computed(() => {
    return {
        'message': incorrectPhone.value,
        'errors': {
            'phone': [incorrectPhone.value]
        }
    }
})

onMounted(async () => {
    if (!props.org_id) {
        return;
    }
    locations.value = await fetchLocations(props.org_id);
    groups.value = props.org_groups;
    getUserTypes(props.org_id);
});

watch(() => props.user.id, () => {
    console.log('user changed');
    const defaultUserTypeId = props.user?.user_type?.[0]?.id ?? 1;
    const index = userTypes.value.findIndex(userType => userType.id === defaultUserTypeId);
    const selectedUserType = userTypes.value[index];
    const matchedRole = selectedUserType.roles.find(role => role.id ===  props.user.roles[0].id);
    const assigningUserHasServicePlusUnlockPermission = hasPermission(auth_user.value.can, 'add.extendedSoftwareService') ?? false;
    const assignedRoleHasServicePlusUnlockPermission = matchedRole?.permissions.includes('add.extendedSoftwareService') ?? false;

    showServicePlusUnlockToggle.value = assigningUserHasServicePlusUnlockPermission && assignedRoleHasServicePlusUnlockPermission;

    console.log(matchedRole);
});

watch(() => sharedState?.value?.reloadUserCreate, async (newValue) => {
    if (newValue) {
        groups.value = await fetchGroups(props.org_id);
        locations.value = await fetchLocations(props.org_id);
        sharedState.value.reloadUserCreate = false;
    }
});


watch(() => selectedUserRole, (newValue) => {
    if (props.user.id && props.user.newRole && newValue.value !== originalRole.value && props.user.newRole !== newValue) {
        props.user.roleChanged = true;
    } else {
        props.user.roleChanged = false;
    }
    props.user.newRole = newValue.value;
}, {immediate: true, deep:true});

defineExpose({
    resetErrors,
    resetUserTypes,
    formatUserLocationsGroups,
    createUser,
    userTypes,
    resetUser,
    setOriginalLocations,
    setOriginalGroups,
    setOriginalRole,
    setOriginalUserType,
    getLocations,
    getGroups
})

</script>

<style scoped>
.bold-label, .bold-input {
    font-weight: bold;
}

</style>
